import { render, staticRenderFns } from "./SidebarPartial.vue?vue&type=template&id=5310ce18&"
import script from "./SidebarPartial.vue?vue&type=script&lang=js&"
export * from "./SidebarPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports